export default __webpack_public_path__ + "static/media/MoreDark.7dfa509d.svg";